import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m9.592 12.301-3.01-4.107c-.15-.205-.089-.482.137-.619A.526.526 0 0 1 6.99 7.5h6.018c.271 0 .491.2.491.447a.419.419 0 0 1-.082.247l-3.01 4.107a.521.521 0 0 1-.68.124.47.47 0 0 1-.136-.124Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
